import { render, staticRenderFns } from "./for_freelancers_mobile.vue?vue&type=template&id=cc2c5e34&scoped=true&"
import script from "./for_freelancers_mobile.vue?vue&type=script&lang=js&"
export * from "./for_freelancers_mobile.vue?vue&type=script&lang=js&"
import style0 from "./for_freelancers_mobile.vue?vue&type=style&index=0&id=cc2c5e34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2c5e34",
  null
  
)

export default component.exports